import React from 'react';
import { Link } from 'react-router-dom';
import { Globe, Share2, Cpu } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="bg-cyber-gray border-t border-gray-800 pt-20 pb-10 relative z-10 font-rajdhani">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-12 mb-16">
                    <div className="col-span-2 md:col-span-1">
                        <span className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-neon-blue to-neon-purple font-orbitron tracking-wider">
                            VectorShift
                        </span>
                        <p className="mt-4 text-gray-400 text-sm leading-relaxed">
                            Empowering developers to build, test, and deploy limitless pipelines with zero latency.
                        </p>
                    </div>

                    <div>
                        <h4 className="text-white font-bold mb-6 font-orbitron tracking-wide text-sm uppercase">Product</h4>
                        <ul className="space-y-4">
                            <li><Link to="/features" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">Features</Link></li>
                            <li><Link to="/integrations" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">Integrations</Link></li>
                            <li><Link to="/templates" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">Templates</Link></li>
                            <li><Link to="/pricing" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">Pricing</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-white font-bold mb-6 font-orbitron tracking-wide text-sm uppercase">Resources</h4>
                        <ul className="space-y-4">
                            <li><a href="https://docs.vectorshift.com" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">Documentation</a></li>
                            <li><a href="https://docs.vectorshift.com/api" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">API Reference</a></li>
                            <li><a href="https://community.vectorshift.com" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">Community</a></li>
                            <li><a href="https://blog.vectorshift.com" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">Blog</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-white font-bold mb-6 font-orbitron tracking-wide text-sm uppercase">Company</h4>
                        <ul className="space-y-4">
                            <li><Link to="/about" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">About Us</Link></li>
                            <li><Link to="/careers" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">Careers</Link></li>
                            <li><Link to="/legal" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">Legal</Link></li>
                            <li><Link to="/contact" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">Contact</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm font-mono">
                    <div>&copy; 2024 VectorShift Inc. All rights reserved.</div>
                    <div className="flex space-x-6 mt-4 md:mt-0">
                        <a href="https://vectorshift.com" className="hover:text-neon-blue transition-colors"><Globe className="w-5 h-5" /></a>
                        <a href="https://twitter.com/vectorshift" className="hover:text-neon-blue transition-colors"><Share2 className="w-5 h-5" /></a>
                        <a href="https://github.com/vectorshift" className="hover:text-neon-blue transition-colors"><Cpu className="w-5 h-5" /></a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
